// import { useGetDraftAnnotationTasksCountQuery, useGetFinalizedAnnotationTasksCountQuery } from "@verantos-dev/feature-annotator-queue";
import { useGetAnnotationAllocationSummaryQuery } from '../api/dashboardApiSlice';

/**
 * Shared hook to get pending tasks count.
 * Can be used by any component that needs this data.
 * RTK Query automatically handles caching and deduplication,
 * so multiple components can use this hook without extra API calls.
 */
// export const usePendingTasksCount = (
//   projectId?: string,
//   batchId?: string,
//   skip: boolean = false
// ) => {
//   const {
//     data: pendingTasksCountData,
//     isLoading,
//     isFetching,
//     error,
//   } = useGetPendingTasksCountQuery(
//     { projectId: projectId || '', batchId: batchId || '' },
//     { skip: skip || false }
//   );

//   return {
//     pendingTasksCount: pendingTasksCountData?.data?.count ?? null,
//     isLoading: isLoading || isFetching,
//     error,
//   };
// };

// export const useDraftTasksCount = (
//   projectId?: string,
//   batchId?: string,
//   skip: boolean = false
// ) => {
//   const {
//     data: draftTasksCountData,
//     isLoading,
//     isFetching,
//     error,
//   } = useGetDraftAnnotationTasksCountQuery(
//     { projectId: projectId || '', batchId: batchId || '' },
//     { skip: skip || false }
//   );

//   return {
//     draftTasksCount: draftTasksCountData?.data?.count ?? null,
//     isLoading: isLoading || isFetching,
//     error,
//   };
// };

// export const useFinalizedTasksCount = (
//   projectId?: string,
//   batchId?: string,
//   skip: boolean = false
// ) => {
//   const {
//     data: finalizedTasksCountData,
//     isLoading,
//     isFetching,
//     error,
//   } = useGetFinalizedAnnotationTasksCountQuery(
//     { projectId: projectId || '', batchId: batchId || '' },
//     { skip: skip || false }
//   );

//   return {
//     finalizedTasksCount: finalizedTasksCountData?.data?.count ?? null,
//     isLoading: isLoading || isFetching,
//     error,
//   };
// };

export const useGetAssigmentCount = (projectId?: string, batchId?: string, skip = false) => {
  const shouldSkip = skip;
  const {
    data: assignmentCountData,
    isLoading,
    isFetching,
    error,
  } = useGetAnnotationAllocationSummaryQuery(
    { projectId: projectId || '', batchId: batchId || '' },
    { skip: shouldSkip }
  );

  return {
    finalizedTasksCount: assignmentCountData?.data?.finalizedCount ?? null,
    draftTasksCount: assignmentCountData?.data?.draftCount ?? null,
    pendingTasksCount: assignmentCountData?.data?.pendingCount ?? null,
    totalTasksCount: assignmentCountData?.data?.totalCount ?? null,
    completedTasksCount: assignmentCountData?.data?.completedCount ?? null,
    isLoading: isLoading || isFetching,
    error,
  };
};
